// extracted by mini-css-extract-plugin
export default {"page":"Manuals_page__VZPXU","toolbar":"Manuals_toolbar__AdEyA","removeBtn":"Manuals_removeBtn__WoF3t","viewBtn":"Manuals_viewBtn__XNACi","returnBtn":"Manuals_returnBtn__LBK4m"};